<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const activeBench = computed(() => store.state.workOrder.activeKey)
const workStatus = computed(() => store.getters.workStatus)

const emptyRemind = [
  '当前为休息状态，无法处理待办，请切换至坐班状态',
  '当前为坐班中（拒收）状态，无法接收工单，请切换至坐班中（接收）状态'
]
const activeArr = {
  2: {
    num: computed(() => store.state.workOrder.pendingCount),
    text: '项待处理的工单，请前往处理'
  },
  3: {
    num: computed(() => store.state.workOrder.processingCount),
    text: '项处理中的工单，请前往处理'
  }
}

const showEmpty = computed(() => {
  if (workStatus.value === 0) {
    return false
  } else if (workStatus.value === 1) {
    return true
  } else {
    return !activeArr[activeBench.value]?.num?.value
  }
})
</script>
<template>
  <div class="empty">
    <template v-if="showEmpty">
      <auth-img class="empty-img" src="@/assets/img/rest-work.png" alt="缺损" />
      <div class="empty-text">
        {{ emptyRemind[workStatus - 1] }}
      </div>
    </template>
    <template v-else>
      <auth-img class="empty-img" src="@/assets/img/empty.png" alt="缺损" />
      <div class="empty-text">
        你有
        <span class="pending-count">
          {{ activeArr[activeBench].num }}
        </span>
        {{ activeArr[activeBench].text }}
      </div>
    </template>
  </div>
</template>
<style lang="scss" scoped>
.empty {
  width: 330px;
  height: 250px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  &-text {
    height: 20px;
    font-size: 14px;
    color: #999999;
    .pending-count {
      color: cornflowerblue;
    }
  }
}
</style>
